import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-voucher-component',
  templateUrl: './voucher-component.component.html',
  styleUrls: ['./voucher-component.component.scss']
})
export class VoucherComponentComponent implements OnInit {

  companies: Array<any> = [];
  companiesTotal: string;
  

  constructor(
    private http: HttpService,
    private errorReport: ErrorReportService,
    private snackbar: MatSnackBar
  ) { }

  ngOnInit(): void {

    this.getCompanies();
    this.getTotalCompanies();
    
  }

  private getTotalCompanies() {

    this.http.get('company:total')
      .subscribe(
        (result: any) => {
          this.companiesTotal = result.data.records;
        },
        err => this.errorReport.showMessage(err)
      )

  }

  private getCompanies(params = {}) {

    this.http.list('company:list', params)
      .subscribe(
        (result: any) => {
          this.companies = result.data;
        },
        err => this.errorReport.showMessage(err)
      )

  }

  setShowUserData(enable, id) {

    const message = enable ? 'Deseja habilitar a visualização de todos os dados para essa empresa ' 
      : 'Deseja desabilitar a visualização de todos os dados para essa empresa ';

    if(!confirm(message))
      return;

    this.http.save('company:show_user_data', { enable, id })
      .subscribe(
        (result: any) => {
          if(result.type === 'OK') {
            this.snackbar.open('Atualização feita com sucesso', 'OK', { duration: 3000 });
            this.getCompanies();
          }            
        },
        err => this.errorReport.showMessage(err)
      )
    

  }

  setVoucher(enable, id) {

    const message = enable ? 'Deseja habilitar o voucher para essa empresa ' : 'Deseja desabilitar o voucher para essa empresa ';

    if(!confirm(message))
      return;

    this.http.save('company:voucher', { enable, id })
      .subscribe(
        (result: any) => {
          if(result.type === 'OK') {
            this.snackbar.open('Voucher atualizado com sucesso', 'OK', { duration: 3000 });
            this.getCompanies();
          }            
        },
        err => this.errorReport.showMessage(err)
      )

  }

  public onPageChange(args: PageEvent) {

    const { pageIndex, pageSize } = args;
    this.getCompanies({
      limit: pageSize,
      pageIndex
    });

  }

}
